// @flow
export function twoDigitMin(num: number | string): string {
  const n = parseInt(num, 10);
  return n > 9 ? `${n}` : `0${n} `;
}

export function parseIntDefault(num: number | string, def: number): number {
  const parsed = parseInt(num, 10);
  return isNaN(parsed) ? def : parsed;
}

export function generateRandomNumber(returnStr?: boolean = false): number | string {
  const n = Math.abs(Date.now() ^ Math.round(Math.random() * 100000));
  return returnStr ? `${n}` : n;
}

export function trimNumberSeparators(num: string): string {
  return num
    .split(' ').join()
    .split(',').join('')
    .split('\'').join('');
}



// WEBPACK FOOTER //
// ./src/utils/number/index.js